import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuthGuard } from "./core/guards/auth.guard";
import { LayoutComponent } from "./layouts/layout.component";
import { Page404Component } from "./extrapages/page404/page404.component";
import { NoPermissionComponent } from "./extrapages/no-permission/no-permission.component";

const routes: Routes = [
  { path: "", redirectTo: "account/login", pathMatch: "full" },

  {
    path: "account",
    loadChildren: () =>
      import("./account/account.module").then((m) => m.AccountModule),
  },
  // Manual de Treinamento — rota pública (sem AuthGuard e sem o layout do app),
  // para que o link possa ser compartilhado com o cliente sem exigir login.
  {
    path: "training",
    loadChildren: () =>
      import("./pages/training/training.module").then((m) => m.TrainingModule),
  },
  // tslint:disable-next-line: max-line-length
  {
    path: "",
    component: LayoutComponent,
    loadChildren: () =>
      import("./pages/pages.module").then((m) => m.PagesModule),
    canActivate: [AuthGuard],
  },
  { path: "no-permission", component: NoPermissionComponent },
  { path: "**", component: Page404Component },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: "top" })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
